import type { TFunction } from 'i18next';
import type { SellableReason } from '@/api/resellerAdmin';

export function notSellableText(
  reason: SellableReason | null,
  currency: string | null,
  t: TFunction,
): string | null {
  switch (reason) {
    case 'NO_RESELLER':
      return t('tenant.notSellable.noReseller');
    case 'CURRENCY_NOT_PRICED':
      return currency?.trim()
        ? t('tenant.notSellable.currency', { currency })
        : t('tenant.notSellable.currencyNotPricedNoCode');
    case 'NO_AGREEMENT':
      return t('tenant.notSellable.noAgreement');
    case 'NO_RATE_CARD':
      return t('tenant.notSellable.noRateCard');
    default:
      return null;
  }
}
